import { Action, Dispatch, AnyAction } from "redux";
import api from "../../api";
interface GetOrderImagesAction extends Action
{
    type: "GET_ORDER_IMAGES";
    images: OrderImage[];
}
interface UpdateOrderImageAction extends Action
{
    type: "GET_ORDER_IMAGE";
    src?: string;
    orderId: string;
    imageType: string;
    uploadStatus: "UPLOADING" | "UPLOADED" | "FAILED";
}

export const uploadImage = (file: File, fileName: string, orderId: string, imageType: string, retries = 0) => async (dispatch: Dispatch<AnyAction>) => 
    {            
        if(retries === 0)
        {
            const action = { type: "GET_ORDER_IMAGE", orderId, imageType, uploadStatus: "UPLOADING" } as UpdateOrderImageAction;
            dispatch(action);
        }

        try{    
                const src = await api.MediaApi.uploadImage(file, fileName, orderId, imageType);
                const action = { src, type: "GET_ORDER_IMAGE", orderId, imageType, uploadStatus: "UPLOADED" } as UpdateOrderImageAction;
                dispatch(action);            
        }
        catch(e)
        {
            if(retries == 10)
                {
                    const action = { type: "GET_ORDER_IMAGE", orderId, imageType, uploadStatus: "FAILED" } as UpdateOrderImageAction;
                    dispatch(action);
                }
                else
                    {
                        setTimeout(() => {
                            dispatch<any>(uploadImage(file, fileName, orderId, imageType, retries + 1));
                        }, 3000);
                    }
                }
                
    }

export const getImages = (orderId: string, debitorId: string) => async (dispatch: Dispatch<AnyAction>) => 
{
    const images = await api.MediaApi.getOrderImages(orderId, debitorId);
    const action = { images, type: "GET_ORDER_IMAGES"} as GetOrderImagesAction;
    dispatch(action);
}

export type Actions =
    GetOrderImagesAction |
    UpdateOrderImageAction;
